import React from 'react'

export default function TopHeading(props) {
  return (
    <h2 className='topbar-heading shadow-sm p-2 my-3 corner-radius'>{props.title}</h2>
  )
}
